<template>
    <div id="contenedor-opciones-tool-bar">
        <v-tabs>
            <template
                v-for="(opcion, index) in opciones">
                <template>
                  <v-tab
                    :key="index"
                    :to="{ name: opcion.ruta }"
                    exact>
                    {{ opcion.nombre }}
                  </v-tab>
                </template>
            </template>
        </v-tabs>
    </div>
</template>

<script>
export default {
  name: 'OpcionesToolBarContratos',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contrato',
          icono: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'contratoAnticipos',
          icono: '',
        },
        {
          nombre: 'Convenios mod.',
          ruta: 'contratoConvenios',
          icono: '',
        },
        {
          nombre: 'Fianzas',
          ruta: 'contratoFianzas',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'contratoCatalogo',
          icono: '',
        },
        {
          nombre: 'Deducciones',
          ruta: 'contratoDeducciones',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratoPrograma',
          icono: '',
        },
        {
          nombre: 'Responsables',
          ruta: 'contratoResponsables',
          icono: '',
        },
        {
          nombre: 'Superintendente',
          ruta: 'contratoSuperintendentes',
          icono: '',
        },
        {
          nombre: 'Actividades',
          ruta: 'contratoActividades',
          icono: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'contratoExpediente',
          icono: '',
        },
        {
          nombre: 'Contrato Relacionados',
          ruta: 'contratoContratosRelacionados',
          icono: '',
        },
        // {
        //   nombre: 'Archivos Contratista',
        //   ruta: 'contratoArchivosContratista',
        //   icono: '',
        // },
        {
          nombre: 'Contrato Diario',
          ruta: 'contratoDiarioActividades',
          icono: '',
        },
        {
          nombre: 'Firmas',
          ruta: 'contratoFirmas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
